<template>
    <div
        class="pro-banner ppv2-flex ppv2-items-center ppv2-justify-between ppv2-p-3 ppv2-rounded-[10px] ppv2-mb-6 ppv2-mt-[24px] ppv2-border ppv2-border-solid ppv2-border-[#4D339F]"
    >
        <div class="ppv2-flex ppv2-items-center" :style="{ gap: normalizeSize(16, true) }">
            <!-- Badge Pro -->
            <div class="badge-pro ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-px-3 ppv2-py-1 ppv2-rounded-full bg-purple">
                <Star :size="14" color="white" />
                <span class="poppinsSemiBold ppv2-text-white ppv2-text-sm ppv2-capitalize">{{ type }}</span>
            </div>

            <!-- Texte -->
            <p class="poppinsLight ppv2-text-[#fff] !ppv2-mb-0" :style="{ fontSize: normalizeFontSize(14) }">
                {{ text || $t('experience.step6.pro_banner_text', { type }) }}
            </p>
        </div>

        <!-- Bouton -->
        <BaseButton variant="primary" :custom-font-size="12" :customHeight="36" @click="handleButtonClick">
            {{ buttonText || $t('experience.step6.passer_pro', { type }) }}
        </BaseButton>
    </div>
</template>

<script>
import { Star } from 'lucide-vue'
import normalizeSize from '../../utils/normalizeSize'
import BaseButton from './BaseButton.vue'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'ProBanner',
    components: {
        Star,
        BaseButton,
    },
    props: {
        text: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
        buttonUrl: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'Pro',
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        handleButtonClick() {
            window.location.href = this.buttonUrl || '/back-office/subscription'
        },
    },
}
</script>

<style scoped>
.pro-banner {
    background: linear-gradient(90deg, #1d1042 0%, #382281 100%);
}

.dark .pro-banner {
    background: linear-gradient(90deg, #1d1042 0%, #382281 100%);
}

.badge-pro {
    box-shadow: 0 2px 8px rgba(125, 45, 189, 0.3);
}

.btn-passer-pro {
    text-decoration: none !important;
}

.border-purple {
    border-color: #7d2dbd !important;
}

.bg-purple {
    background-color: #7d2dbd !important;
}

.text-purple {
    color: #7d2dbd !important;
}
</style>
